import { render } from "./BaseIcon.vue?vue&type=template&id=7ace39e4"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__